import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export function apiGetVisualAids({ vin }) {
  return api.get(`/vin/${vin}/visual-aids`).then((resp) => resp.data)
}
